export class AdditionalDocument{
    public documentId: number = 0;
    public documentType: string  = '';
    public effetiveDTTM!: number;
    public expiryDTTM!: number;
    public effectiveDTTMText!: string;
    public expiryDTTMText!: string;    
    public docNameWithExtension!: string;
    public licenseState: string = '';
    public licenseNumber: string = '';
    public documentName: string = '';
    public documentFile: any;   
    public doesNotExpire : boolean = false; 
}